import { gql } from '@apollo/client';
import moment from 'moment';
import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import Avatar from '../components/Avatar';
import USER_AVATAR_FRAGMENT from '../graphql/fragments/UserAvatar';
import type { VerificationEntry_VerificationEntryFragment } from '../graphql/generated/graphqlTypes';
import userPath from '../utils/url/userPath';
import yearSensitiveDateString from '../utils/yearSensitiveDateString';
import styles from './VerificationEntry.module.scss';

const VERIFICATION_ENTRY_FRAGMENT = gql`
  fragment VerificationEntry_verificationEntry on VerificationEntry {
    verifiedAt
    expiredAt
    verifier {
      id
      name
      title
      ...UserAvatar
    }
  }
  ${USER_AVATAR_FRAGMENT}
`;

interface VerificationEntryProps {
  verificationEntry: VerificationEntry_VerificationEntryFragment;
}

const VerificationEntry = ({
  verificationEntry: { verifiedAt, expiredAt, verifier },
}: VerificationEntryProps) => (
  <div className={styles.container}>
    <Link to={userPath(verifier)} className={styles.verifier}>
      <div>
        <Avatar user={verifier} size={24} />
      </div>
      <div className={styles.verifierName}>{verifier.name}</div>
    </Link>
    <div className={styles.dateRange}>
      {yearSensitiveDateString(verifiedAt, 'MMM D', expiredAt)} -{' '}
      {moment(expiredAt).format('MMM D, YYYY')}
    </div>
  </div>
);

VerificationEntry.fragments = {
  verificationEntry: VERIFICATION_ENTRY_FRAGMENT,
};

export default VerificationEntry;
